import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'

import { cn } from '~/shadcn/lib/utils'

function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        'bg-primary/20 relative h-1 w-full overflow-hidden rounded-full',
        className
      )}
      {...props}>
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-accent h-full w-full flex-1 transition-all"
        style={{
          transform: `scaleX(${(value || 0) / 100})`,
          transformOrigin: 'left',
        }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
